module.exports = __webpack_public_path__ + "img/alex-profile-min.d3403683.jpg";